import React, { useState } from 'react';
import pinIcon from '../Assets/Pin-icon.png';
import micIcon from '../Assets/mic-icon.png';
import sendIcon from '../Assets/send-icon.png';

const MessageInput = ({ onSend }) => {
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault(); // Prevent form reload
    if (!message.trim()) return;

    try {
      setIsLoading(true);
      await onSend(message); // Send to parent (Chat or Discover screen)
      setMessage('');
    } catch (err) {
      console.error('Error sending message:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSend}
      className="p-4 md:p-6 rounded-3xl bg-yellow-100/50 flex items-center gap-3 shadow-sm"
    >
      <img src={pinIcon} alt="Attach file" className="w-5 h-5 cursor-pointer" />

      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Type a message..."
        className="flex-1 bg-transparent text-stone-800 placeholder:text-stone-500 outline-none text-base font-sora"
        disabled={isLoading}
      />

      <img src={micIcon} alt="Voice message" className="w-4 h-4 cursor-pointer" />

      <button
        type="submit"
        className={`p-2 md:p-3 rounded-[60px] transition ${
          isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-red-600'
        }`}
        aria-label="Send message"
        disabled={isLoading}
      >
        <img src={sendIcon} alt="Send" className="w-8 h-8 md:w-12 md:h-12" />
      </button>
    </form>
  );
};

export default MessageInput;
